<template>
  <tr :class="'border-b border-gray-300 ' + (index % 2 == 0 ? 'bg-gray-100' : 'bg-white')" v-on:click="clientSelected()">
  <!-- <tr class="border-b border-gray-300" v-on:click="clientSelected()"> -->
    <td class="p-4 border-r">

      <div class="flex justify-between">
        <div class="">
          <template v-for="(applicant, index) in applicants">
            <router-link
              :to="{
                name : 'application-applicant-profile',
                params : {
                  clientId   : client.id,
                  applicantId: applicant.id
                }
              }"
              tag="a"
              v-on:click.stop
              :class="{ 'block text-blue-700 no-underline hover:underline text-sm' : true, 'mt-1' : index > 0 }">{{ applicant.name }}</router-link>
          </template>
        </div>

        <div v-if="client.lead_capture_id != null">
          <div class="inline-block w-2 h-2 bg-purple-500 rounded-full" 
            v-tooltip.top="{ content : 'This client was added via lead capture form.' }"></div>
        </div>
      </div>
    </td>

    <td class="p-4 border-r">
      {{ applicants[0].email }}
      <!-- <a class="text-blue-700 no-underline hover:underline text-sm"
        :href="'mailto:' + applicants[0].email">{{ applicants[0].email }}</a> -->
    </td>

    <td class="p-4 border-r">{{ applicants[0].mobile }}</td>

    <td class="p-4 border-r text-center">
      {{ client.num_documents_received == null ? 0 : client.num_documents_received }} 
      / 
      {{ client.num_documents_requested == null ? 0 : client.num_documents_requested }}
    </td>

    <td class="p-4 border-r">
      <router-link
        :to="{
          name : 'client-activity',
          params : {
            clientId: client.id
          }
        }"
        tag="a"
        v-on:click.stop
        :class="{ 'block text-blue-700 no-underline hover:underline text-sm' : true, 'mt-1' : index > 0 }">{{ getFormattedDate(client.last_activity_timestamp, 'YYYY-MM-DD HH:mm:ss', 'D MMM YYYY HH:mm') }}</router-link>
    </td>

    <td class="p-4 border-r">
      <div class="overflow-hidden">
        <template v-if="client.status == 0 || client.loan_status == 'broker-created-loan'">
          <div class="float-left">
            <div class="inline-block bg-red-500 rounded-full"
              style="margin-top:1px;width:12px;height:12px;"></div>
          </div>
          <div class="float-left ml-2 text-gray-700">Not sent</div>
        </template>

        <template v-else-if="client.status == 1">
          <div class="float-left">
            <div class="inline-block bg-orange-500 rounded-full"
              style="margin-top:1px;width:12px;height:12px;"></div>
          </div>
          <div class="float-left ml-2 text-gray-700">Sent</div>
        </template>

        <template v-else-if="client.status == 2">
          <div class="float-left">
            <div class="inline-block bg-blue-500 rounded-full"
              style="margin-top:1px;width:12px;height:12px;"></div>
          </div>
          <div class="float-left ml-2 text-gray-700">Received</div>
        </template>

        <template v-else-if="client.status == 3">
          <div class="float-left">
            <div class="inline-block bg-green-500 rounded-full"
              style="margin-top:1px;width:12px;height:12px;"></div>
          </div>
          <div class="float-left ml-2 text-gray-700">Completed by broker</div>
        </template>
      </div>
    </td>

    <td class="p-4 border-r">
      <template v-if="client.client_token_created_at != null">
        <div class="overflow-hidden">
          <div class="float-left">
            <a href="#" @click.prevent.stop="toggleAccess('disable')"
              class="no-underline hover:underline text-green-500 text-xs uppercase font-semibold"
              v-tooltip.right="{ content : 'Click to disable login for this user' }">Enabled</a>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="overflow-hidden">
          <div class="float-left">
            <template v-if="client.status == 0">
              <a href="#" @click.prevent.stop="toggleAccess('enable')"
                class="no-underline hover:underline text-red-500 text-xs uppercase font-semibold"
                v-tooltip.right="{
                  content : 'You have not sent the application to the client. Click here to send.'
                }">Disabled</a>
            </template>

            <template v-else>
              <a href="#" @click.prevent.stop="toggleAccess('enable')"
                class="no-underline hover:underline text-red-500 text-xs uppercase font-semibold"
                v-tooltip.right="{ content : 'Click to enable login for this user' }">Disabled</a>
            </template>
          </div>
        </div>
      </template>
    </td>

    <td class="p-2 text-center">
      <button class="w-full bg-gray-600 text-white text-xs font-semibold hover:bg-blue-500 outline-none"
        style="padding:9px 0;" v-on:click="clientSelected()">Actions</button>
    </td>
  </tr>
</template>

<script>
  import { EventBus } from '@/shared/event-bus';

  export default {

    props : {
      client : {
        type    : Object,
        required: true
      },

      index : {
        type    : Number,
        required: true
      },
    },

    data() {
      return {
        showApplicants : false
      }
    },

    computed : {
      applicants() {
        
        let applicants = []
        let ids        = this.client.applicant_ids.split(",")
        let names      = this.client.applicant_names.split(",")
        let emails     = this.client.applicant_emails.split(",")
        let mobiles    = this.client.applicant_mobiles.split(",")
        let firstNames = this.client.applicant_first_names.split(",")
        
        for(let i=0; i < ids.length; i++) {
          applicants.push({
            id       : ids[i],
            name     : names[i],
            firstName: firstNames[i],
            email    : emails[i] == '-' ? null : emails[i],
            mobile   : mobiles[i] == '-' ? null : mobiles[i]
          })
        }

        return applicants
      },
    },

    methods: {

      clientSelected() {
        this.client.applicants = this.applicants
        EventBus.$emit('open-client-actions', this.client)
      },

      toggleAccess(enableOrDisable) {
        EventBus.$emit('toggle-access', {
          clientId       : this.client.id, 
          enableOrDisable: enableOrDisable
        })
      }
    }
  }
</script>